import api from './api';

const ChefeDepartamentoService = {
  // Obter estatísticas gerais para o dashboard
  async getEstatisticasGerais() {
    try {
      const response = await api.get('/dashboard/chefe-departamento');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas gerais:', error);
      throw error;
    }
  },

  // Listar todos os supervisores disponíveis
  async listarSupervisores() {
    try {
      const response = await api.get('/supervisores/disponiveis');
      return response.data;
    } catch (error) {
      console.error('Erro ao listar supervisores disponíveis:', error);
      throw error;
    }
  },

  // Listar todos os revisores disponíveis
  async listarRevisores() {
    try {
      const response = await api.get('/usuarios/revisores');
      return response.data;
    } catch (error) {
      console.error('Erro ao listar revisores disponíveis:', error);
      throw error;
    }
  },

  // Designar supervisor para uma proposta
  async designarSupervisor(propostaId, supervisorId) {
    try {
      const response = await api.post(`/propostas/${propostaId}/designar-supervisor`, {
        supervisorId
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao designar supervisor:', error);
      throw error;
    }
  },

  // Encaminhar projeto para revisor
  async encaminharProjetoParaRevisor(projetoId, revisorId) {
    try {
      const response = await api.post('/projetos/encaminhar-revisor', {
        projetoId,
        revisorId
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao encaminhar projeto para revisor:', error);
      throw error;
    }
  },

  // Aprovar projeto e emitir credencial
  async aprovarProjetoCredencial(projetoId, dados) {
    try {
      const response = await api.post(`/projetos/${projetoId}/aprovar`, dados);
      return response.data;
    } catch (error) {
      console.error('Erro ao aprovar projeto com credencial:', error);
      throw error;
    }
  },

  // Encaminhar monografia para revisão
  async encaminharMonografiaParaRevisao(monografiaId, revisorId) {
    try {
      const response = await api.post('/monografias/encaminhar-revisao', {
        monografiaId,
        revisorId
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao encaminhar monografia para revisão:', error);
      throw error;
    }
  },

  // Aprovar monografia
  async aprovarMonografia(monografiaId, observacoes) {
    try {
      const response = await api.put(`/monografias/${monografiaId}/aprovar`, {
        observacoes
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao aprovar monografia:', error);
      throw error;
    }
  },

  // Agendar defesa
  async agendarDefesa(dados) {
    try {
      const response = await api.post('/defesas', dados);
      return response.data;
    } catch (error) {
      console.error('Erro ao agendar defesa:', error);
      throw error;
    }
  },

  // Listar defesas pendentes
  async listarDefesasPendentes() {
    try {
      const response = await api.get('/defesas?status=AGENDADA');
      return response.data;
    } catch (error) {
      console.error('Erro ao listar defesas pendentes:', error);
      throw error;
    }
  },

  // Método principal para obter estatísticas de avaliações
  async getEstatisticasAvaliacoes() {
    try {
      const response = await api.get("/avaliacoes");
      const avaliacoes = response.data;

      return {
        total: avaliacoes.length,
        avaliacoes: avaliacoes,
        estatisticas: {
          concluidas: avaliacoes.filter(av => this.verificarConclusao(av)).length,
          mediaGeral: this.calcularMediaGeral(avaliacoes),
          distribuicaoNotas: this.calcularDistribuicaoNotas(avaliacoes)
        },
        recentes: avaliacoes
          .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          .slice(0, 5)
      };
    } catch (error) {
      console.error('Erro ao buscar estatísticas de avaliações:', error);
      throw error;
    }
  },

  // Métodos auxiliares
  verificarConclusao(avaliacao) {
    return avaliacao.arguenteTotal && 
           avaliacao.presidenteTotal && 
           avaliacao.supervisorTotal;
  },

  calcularMediaGeral(avaliacoes) {
    const avaliacoesConcluidas = avaliacoes.filter(av => this.verificarConclusao(av));
    if (!avaliacoesConcluidas.length) return 0;
    
    const soma = avaliacoesConcluidas.reduce((acc, av) => acc + av.mediaFinal, 0);
    return (soma / avaliacoesConcluidas.length).toFixed(2);
  },

  calcularDistribuicaoNotas(avaliacoes) {
    return avaliacoes.reduce((acc, av) => {
      if (!this.verificarConclusao(av)) return acc;

      const nota = av.mediaFinal;
      if (nota >= 17) acc.excelente++;
      else if (nota >= 15) acc.muitoBom++;
      else if (nota >= 13) acc.bom++;
      else if (nota >= 10) acc.suficiente++;
      else acc.insuficiente++;

      return acc;
    }, {
      excelente: 0,
      muitoBom: 0,
      bom: 0,
      suficiente: 0,
      insuficiente: 0
    });
  }
};

export default ChefeDepartamentoService;